import React, { useState } from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { STATUS_LABELS } from '../../configs/analytics.config';

const AnalyticsExport = ({ rawTasks, rangeKey }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = () => {
    if (!rawTasks || rawTasks.length === 0) {
      message.warning('No data to export');
      return;
    }

    setExporting(true);

    import('xlsx')
      .then((XLSX) => {
        const rows = rawTasks.map((task) => {
          const assignees =
            task.assigneeUsers?.length
              ? task.assigneeUsers.map((u) => u.name).join('; ')
              : task.assigneeUser?.name || '';

          const advertiserType =
            task.createdBy?.roles?.[0]?.org?.level
              ?.split('_')
              .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
              .join(' ') || '';

          const advertiserOrg = task.createdBy?.roles?.[0]?.org?.name || '';

          return {
            STATUS: STATUS_LABELS[task.status] || task.status,
            'REQUEST TYPE': task.requestType || '',
            'REQUEST SUB TYPE': task.requestSubType || '',
            URGENCY: task.urgency || '',
            ASSIGNEE: assignees,
            REQUESTOR: task.createdBy?.name || '',
            "REQUESTOR'S ORG": advertiserOrg,
            "REQUESTOR'S ORG TYPE": advertiserType,
            ADVERTISER: task.advertiser?.name || '',
            'CHANNEL PARTNER': task.channelPartner?.name || '',
            PROJECT: task.project?.name || '',
            'DUE DATE': task.dueDate
              ? new Date(task.dueDate).toLocaleDateString('en-CA')
              : '',
            'CREATED DATE': task.createdAt
              ? new Date(task.createdAt).toLocaleDateString()
              : '',
            'LAST UPDATED': task.updatedAt
              ? new Date(task.updatedAt).toLocaleDateString()
              : '',
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(rows);
        worksheet['!cols'] = [
          { wch: 18 }, { wch: 20 }, { wch: 20 }, { wch: 12 },
          { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 20 },
          { wch: 25 }, { wch: 25 }, { wch: 25 }, { wch: 12 }, { wch: 15 }, { wch: 15 },
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Analytics');

        XLSX.writeFile(
          workbook,
          `task_analytics_${rangeKey?.replace(/\s+/g, '_') || 'export'}_${new Date().toISOString().split('T')[0]}.xlsx`
        );

        message.success(`${rawTasks.length} tasks exported successfully!`);
      })
      .catch((error) => {
        console.error('Failed to load xlsx library:', error);
        message.error('Failed to export data');
      })
      .finally(() => {
        setExporting(false);
      });
  };

  return (
    <Button
      type="link"
      icon={<DownloadOutlined />}
      onClick={handleExport}
      loading={exporting}
      disabled={!rawTasks || rawTasks.length === 0}
    >
      Export
    </Button>
  );
};

export default AnalyticsExport;
